import { withScopeContext } from '@mews/framework';
import { connectPaymentItem } from './connectPaymentItem';
import { PaymentItem as PaymentItemPure } from './PaymentItem';

export const PaymentItem = withScopeContext(connectPaymentItem(PaymentItemPure));

export { PaymentItemLinkedToReservation } from './PaymentItem';
